import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCanXmark } from "./faTrashCanXmark";

interface Props {
  /** Icon size in px. */
  size?: number;
  /** Explicit color; when omitted the icon inherits the current text color. */
  color?: string;
}

/** Standard "delete" trash icon used across the app (custom Figma spec). */
export default function TrashIcon({ size = 16, color }: Props) {
  return (
    <FontAwesomeIcon
      icon={faTrashCanXmark}
      style={color ? { fontSize: size, color } : { fontSize: size }}
    />
  );
}
